import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightBulb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"light-bulb, idea, light"} maskId="square-filled-radius-0-stroke-1-IconLightBulb"><path d="M20 9C20 11.3899 18.952 13.5345 17.2915 15H6.70846C5.04803 13.5345 4 11.3899 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9Z" fill="currentColor"/><path d="M8 19V16H16V19H8Z" fill="currentColor"/><path d="M16 22V21H8V22H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLightBulb;
